import { RequestAction } from '@redux-requests/core';

import { Source } from 'shared/types/source';

import * as actions from './actions';
import { ViewSourceAction, SourceToViewAction } from './types';

export const viewSource = (source: Source): ViewSourceAction => ({
  type: actions.VIEW_SOURCE,
  payload: { source },
});

export const setSourceToView = (sourceToView: Source): SourceToViewAction => ({
  type: actions.SET_SOURCE_TO_VIEW,
  payload: { sourceToView },
});

export const fetchSourceStatus = (source: Source): RequestAction => ({
  type: actions.FETCH_SOURCE_STATUS,
  payload: {
    request: {
      url: `/services/sources/${source.id}/status`,
    },
  },
});
